import request from '@/utilsCloud/request'
import port from './port'

// 获取公共课程库列表菜单
export function getEntpOtherConfig(query) {
  return request({
    url: port.course + '/otherConfig/getEntpOtherConfig',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}



export function userTokenFailure(query) {
  return request({
    url: port.course + '/employee/userTokenFailure',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}




// 获取公共课程库列表菜单
export function getEnterpriseWebsite(query) {
  return request({
    url: port.biz + '/enterprise/getEnterpriseWebsite',
    headers: {
      isToken: false,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 获取公共课程库列表菜单
export function getNoticeLittleRedCount(query) {
  return request({
    url: port.biz + '/notice/getNoticeLittleRedCount',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 获取培训类型配置
export function getEntpConfigDefault(query) {
  return request({
    url: '/eceping-course/courseConfig/getEntpConfigDefault',
    method: 'get',
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/apiCloud/common.js